import * as Sentry from '@sentry/remix';

const dsn = typeof window !== 'undefined'
  ? (window as Record<string, unknown>).__SENTRY_DSN__ as string | undefined
  : import.meta.env.VITE_SENTRY_DSN;

const enabled = Boolean(dsn);

export function initSentry(side: 'client' | 'server') {
  if (!enabled) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE ?? 'development',
    tracesSampleRate: side === 'client' ? 0.2 : 0.5,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: side === 'client' ? 1.0 : 0,
    beforeSend(event) {
      // Strip PII from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((b) => ({
          ...b,
          data: undefined,
        }));
      }
      return event;
    },
  });
}

export { Sentry, enabled as sentryEnabled };
